import React from 'react'

type ChevronIconProps = {
  direction: 'left' | 'right'
  size?: number
}

/**
 * Minimal 16px chevron for the pagination footer's Prev/Next buttons.
 *
 * Local (like the sibling PlusIcon) rather than `ext-ui/svg/icon/ChevronIcon`
 * because that primitive is a fixed 24px glyph filled with the brand cta color;
 * the footer needs a 16px chevron (prototype: `size-[16px]`) that inherits the
 * footer button's secondary-text color via `currentColor`, so the button's
 * `:disabled` opacity dims the chevron with it. Decorative — `aria-hidden`; the
 * button carries the accessible name (`aria-label`).
 *
 * TODO(design-system): remove once ext-ui ships a size/color-flexible chevron —
 * tracked on the docked ADS feedback list alongside PlusIcon and the M1 gaps.
 */
export function ChevronIcon({
  direction,
  size = 16,
}: ChevronIconProps): React.ReactElement {
  const d = direction === 'left' ? 'M10 3.5 L5.5 8 L10 12.5' : 'M6 3.5 L10.5 8 L6 12.5'
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill={'none'}
      aria-hidden={'true'}
    >
      <path
        d={d}
        stroke={'currentColor'}
        strokeWidth={1.5}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
}
